import styles from './index.module.css';
import DOMPurify from 'dompurify';
const Parts = ({ textData ,language}) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text46']),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text47']),
          }}
        ></h5>
        <h6
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text48']),
          }}
        ></h6>
      </div>

      <div className={styles.gridColumns}>
        <div className={styles.gridRows}>
          <img
            src={`https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-accessories-01${language === 'cn' ? '' : '-en'}.jpg`}
            alt=""
          />

          <img
            src={`https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-accessories-02${language === 'cn' ? '' : '-en'}.jpg`}
            alt=""
          />
        </div>

        <div className={styles.gridRows}>
          <img
            data-speed="1.2"
            src={`https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-accessories-03${language === 'cn' ? '' : '-en'}.jpg`}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Parts;
